import { LicenseReviewed } from '../../medFile/MedFile';
export class ImgLegacy {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get img() {
        return this.parent;
    }
    fromLegacy(legacyImageRow) {
        const img = this.img;
        const trait = img.parent;
        img.legacyId = legacyImageRow.id;
        img.legacyQuestionId = legacyImageRow.question_id;
        img.legacyFileSize = legacyImageRow.filesize;
        img.legacyFilePath = legacyImageRow.id ? `/data/images/${legacyImageRow.id}.${legacyImageRow.fileextension}` : '';
        img.legacyFileExtension = legacyImageRow.fileextension;
        img.medFileSource.rightHolder = legacyImageRow.author;
        img.medFileSource.licenseReviewed = fromLicenseCheckedField(legacyImageRow.checked);
        img.medFileSource.duplicates = legacyImageRow.duplicates;
        if (!!legacyImageRow.file_width)
            img.naturalWidth_pixel = legacyImageRow.file_width;
        if (!!legacyImageRow.file_height)
            img.naturalHeight_pixel = legacyImageRow.file_height;
        if (!!legacyImageRow.license)
            img.medFileSource.licenseUrl = legacyImageRow.license;
        if (!!legacyImageRow.link)
            img.medFileSource.sourcePageUrl = legacyImageRow.link;
        if (!!legacyImageRow.note)
            img.medFileSource.note = legacyImageRow.note;
        // img.medFileEdit.editSearchTerm = legacyImageRow.search;
        img.medFileSource.sourceFileUrl = legacyImageRow.source;
        img.medFileSource.alternativeText = legacyImageRow.text;
        trait.aspect.local.valueOf.imageWidth = legacyImageRow.width;
        trait.aspect.local.valueOf.imageHeight = legacyImageRow.height;
        img.trait.local.valueOf.imageZoomable = legacyImageRow.zoomable;
    }
}
function fromLicenseCheckedField(n) {
    if (n === 0)
        return LicenseReviewed.No;
    if (n === 1)
        return LicenseReviewed.Yes;
    return LicenseReviewed.AtUpload;
}
function toLicenseCheckedField(v) {
    if (v === LicenseReviewed.No)
        return 0;
    if (v === LicenseReviewed.Yes)
        return 1;
    return 2;
}
